"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M15 5.619h1V.897c0-.532-.36-.774-.697-.774h-4.779v1h3.814L5.662 9.675l.702.712L15 1.874V5.62Zm-4.732 10.26H2.15A2.152 2.152 0 0 1 0 13.73V5.884c0-1.185.965-2.15 2.15-2.15h6.817v1H2.15A1.15 1.15 0 0 0 1 5.884v7.847c0 .634.516 1.15 1.15 1.15h8.118c.634 0 1.15-.516 1.15-1.15V7.25h1v6.48c0 1.186-.964 2.15-2.15 2.15Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M22.873 8.367h1.125v-7.2c0-.676-.434-.98-.863-.98h-7.287v1.126h6.302L8.575 14.693l.79.802L22.872 2.179v6.188Zm-7.416 15.445H3.08a3.081 3.081 0 0 1-3.078-3.078V8.77A3.081 3.081 0 0 1 3.08 5.692h10.394v1.125H3.08A1.955 1.955 0 0 0 1.127 8.77v11.965c0 1.076.876 1.953 1.953 1.953h12.377a1.955 1.955 0 0 0 1.953-1.953v-9.879h1.125v9.879a3.081 3.081 0 0 1-3.078 3.078Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M30.497 11.156h1.5V1.557c0-.903-.578-1.307-1.15-1.307h-9.716v1.5h8.402l-18.1 17.842 1.053 1.068L30.497 2.906v8.25ZM20.61 31.75H4.107a4.109 4.109 0 0 1-4.104-4.104V11.694A4.109 4.109 0 0 1 4.107 7.59h13.858v1.5H4.107a2.607 2.607 0 0 0-2.604 2.604v15.952a2.607 2.607 0 0 0 2.604 2.604H20.61a2.607 2.607 0 0 0 2.604-2.604V14.475h1.5v13.171a4.109 4.109 0 0 1-4.104 4.104Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M46.05 16.697h1.875V2.224c0-1.311-.83-1.777-1.541-1.777H31.736v1.875h13.14L17.25 29.552l1.316 1.336L46.05 3.797v12.9Zm-15.1 30.856H6.07a6 6 0 0 1-5.995-5.994V17.508a6.001 6.001 0 0 1 5.994-5.994h20.886v1.875H6.07a4.123 4.123 0 0 0-4.119 4.119v24.05a4.123 4.123 0 0 0 4.12 4.12h24.88a4.124 4.124 0 0 0 4.12-4.12v-19.85h1.874v19.85a6 6 0 0 1-5.994 5.995Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M61.4 22.263h2.5V2.966c0-1.75-1.107-2.37-2.055-2.37h-19.53v2.5h17.52L23 39.404l1.755 1.78L61.4 5.062v17.2Zm-20.133 41.14H8.092C3.685 63.404.1 59.82.1 55.413V23.344c0-4.406 3.585-7.992 7.992-7.992H35.94v2.5H8.092A5.498 5.498 0 0 0 2.6 23.344v32.068a5.498 5.498 0 0 0 5.492 5.492h33.175a5.499 5.499 0 0 0 5.492-5.492V28.945h2.5v26.467c0 4.407-3.585 7.992-7.992 7.992Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconOffsite = function IconOffsite(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Offsite' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Offsite"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconOffsite.sizes = [16, 24, 32, 48, 64];
IconOffsite.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconOffsite;
exports.default = _default;